import { createContext, useContext } from 'react';

export type AppMode = 'simple' | 'full';

export const AppModeContext = createContext<{
  mode: AppMode;
  setMode: (m: AppMode) => void;
  forced: boolean;
  /** Show worker names in the forms transliterated to Arabic letters. */
  arabicNames: boolean;
  setArabicNames: (on: boolean) => void;
}>({
  mode: 'full',
  setMode: () => {},
  forced: false,
  arabicNames: false,
  setArabicNames: () => {},
});

export function useAppMode() {
  return useContext(AppModeContext);
}
